import {combineReducers} from "redux";
import {reducer as actionsReducer} from '../Components/Action';
import {reducer as imagesReducer } from '../Components/Image';
import {reducer as editorReducer } from '../Components/CardBuilder';
import {reducer as notificationsReducer } from '../Components/SnackBar';
import {reducers as businessCardReducers , actionTypes as businessCardActionTypes} from '../Components/BusinessCard';
import {reducer as LoadingIndicatorReducer } from '../Components/LoadingIndicator';
import fetchStateReducer from '../libs/utils/fetchStateReducer';
import resetStateReducer from '../libs/utils/resetStateReducer';
import initialState from './initialState';
// console.log("reducers")
// console.log(businessCardReducers)

const {settingsReducer,clientInfoReducer} = businessCardReducers;

const actionTypes = {
  isLoadingActionType:[businessCardActionTypes.fetchCard],
  successActionType:[businessCardActionTypes.fetchCardSuccess],
  errorActionType:[businessCardActionTypes.fetchCardError]
};

const businessCardRedcuer = combineReducers({
  clientInfo: clientInfoReducer,
  settings: settingsReducer,
  cardActions: actionsReducer,
  images: imagesReducer
});

const appReducer = combineReducers({
  snackbar: notificationsReducer,
  LoadingIndicator: LoadingIndicatorReducer
});

const rootReducer = combineReducers({
  businessCards: fetchStateReducer(actionTypes)(resetStateReducer(businessCardActionTypes.resetCard,initialState.businessCards)(businessCardRedcuer)),
  app: appReducer,
  editor: editorReducer
});


export default rootReducer;